import { Form } from '@/components';
import { MasterTranslation, SignUpSource } from '@/constants';
import { useGlobalState } from '@/hooks';
import { LoginMethod } from '@/interfaces';
import { Divider } from '@/modules/pmt/components/Divider';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import { isEmailSignInShown } from '@/utils/emailSignIn.utils';
import { useSignIn } from '../../../../../hooks/useSignIn.hook';
import { LoginEsyncButton } from '../../../../LoginEsyncButton';
import { PropositionList } from '../PropositionList';
import { Badge, PopupContentWrapper, Subtitle, Title, TopSection } from './PopupContent.styles';

export const PopupContent: React.FC<IPmtOnboardingPopup> = ({
  joinUsValuePropositionList,
  joinUsHeader,
  joinUsDesktopMainText,
  joinUsSubtext,
  loginByEmail,
  desktopGoogleCta,
  identifier,
  subPmcNewsletterText,
  delayTime,
  zapierHookId,
}) => {
  const { t } = useGlobalState();

  const { handleSuccess, triggerGtmClickJoinUs, EmailField, cta } = useSignIn({
    identifier,
    subPmcNewsletterText,
    delayTime,
    zapierHookId,
  });

  return (
    <PopupContentWrapper>
      <TopSection>
        <div>
          {joinUsHeader && <Badge>{joinUsHeader}</Badge>}
          {joinUsDesktopMainText && <Title>{joinUsDesktopMainText}</Title>}
          {joinUsSubtext && <Subtitle>{joinUsSubtext}</Subtitle>}
        </div>
        <PropositionList list={joinUsValuePropositionList} />
      </TopSection>

      <LoginEsyncButton
        googleCta={desktopGoogleCta}
        handleClick={() => triggerGtmClickJoinUs(LoginMethod.Google)}
        handleSuccess={handleSuccess}
      />

      {!!loginByEmail && isEmailSignInShown() && (
        <>
          <Divider>{t(MasterTranslation.TrackManually)}</Divider>

          {/* Email */}
          <Form
            formFieldList={[EmailField]}
            buttonText={t(MasterTranslation.Continue)}
            submittingButtonText={t(MasterTranslation.Submitting)}
            promptBoxContent={t(MasterTranslation.ExistEmailPromptBox)}
            signUpSource={SignUpSource.ConsumerWeb}
            isEmailForm
            isPMTButton
            truncate
            onSuccess={() => triggerGtmClickJoinUs(LoginMethod.Email)}
            cta={cta}
          />
        </>
      )}
    </PopupContentWrapper>
  );
};
